module.exports = __webpack_public_path__ + "img/addAdmin.a5442349.png";